<script lang="ts">
    import Icon from "../parts/Icon.svelte";
    import type {Message} from "../@type";
    import {createEventDispatcher} from "svelte";
    import ReplyButton from "../parts/ReplyButton.svelte";

    export let message: Message;
    export let replyMessageId: string = null;

    const dispatcher = createEventDispatcher();

</script>
<div on:click>
    <div class="message-header">
        <span class="message-title">
          <slot name="title">{message.name}</slot>
        </span>
        <slot name="selectDesign"/>
    </div>
    <div class="message-body {message.metadata?.bodyClass}">
        <slot>
            <Icon icon={message.icon} name={message.name} on:click={dispatcher('icon-click', message)}/>
            <slot name="body">
                <div class="text">{message.body}</div>
            </slot>
        </slot>
    </div>
    <div class="message-action">
        {#if replyMessageId}
            <ReplyButton {replyMessageId} on:reply/>
        {/if}
        <span class="date-box">{message.date}</span>
    </div>
</div>
<style>
    .message-header {
        display: flex;
    }

    .message-title {
        display: inline-block;
        top: 0;
        left: 0;
        margin-top: 4px;
        padding: 0 9px;
        height: 2em;
        line-height: 2em;
        font-size: 1.5ex;
        background: darkgreen;
        color: #ffffff;
        font-weight: bold;
    }

    .message-body {
        position: relative;
        display: flex;
        padding: 0.2em;
    }

    .message-body > * {
        margin-right: 0.5em
    }

    .message-body .text {
        margin: 0;
        padding: 0;
        white-space: pre-line
    }
</style>